import { Routes } from '@angular/router';
import { HomeDashboardComponent } from './shared/components/dashboard/home-dashboard/home-dashboard.component';
import { SolarDashboardComponent } from './shared/components/dashboard/solar-dashboard/solar-dashboard.component';
import { NonSolarDashboardComponent } from './shared/components/dashboard/non-solar-dashboard/non-solar-dashboard.component';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { CustomerDashboardComponent } from './shared/components/dashboard/customer-dashboard/customer-dashboard.component';
import { PlantDetailComponent } from './customer/components/plant-detail/plant-detail.component';
import { authGuard,authGuardSI } from './shared/guard/auth.guard';
import { PlantManagementComponent } from './shared/components/plant-management/plant-management.component';
import { AlertsComponent } from './shared/components/alerts/alerts.component';
import { FAQsComponent } from './customer/components/faqs/faqs.component';
import { VideoGuideComponent } from './customer/components/video-guide/video-guide.component';
import { ContactUsComponent } from './customer/components/contact-us/contact-us.component';
import { UserProfileComponent } from './customer/components/user-profile/user-profile.component';
import { AboutUsComponent } from './customer/components/about-us/about-us.component';
import { AddSecondaryUserComponent } from './customer/components/add-secondary-user/add-secondary-user.component';
import { SolarRooftopComponent } from './shared/components/solar-rooftop/solar-rooftop.component';
import { LargeScalePlantComponent } from './large-scale-plant/large-scale-plant.component';
import { HoliumDashboardComponent } from './shared/components/holium-dashboard/holium-dashboard.component';


export const routes: Routes = [
 
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'system-integrator',
    component: LayoutComponent,
    canActivate: [authGuardSI],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        children: [
          {
            path: '',
            redirectTo: 'home',
            pathMatch: 'full',
          },
          {
            path: 'home',
            component: HomeDashboardComponent,
          },
          {
            path: 'solar',
            component: SolarDashboardComponent,
          },
          {
            path: 'non-solar',
            component: NonSolarDashboardComponent,
          },
          
        ],
      },
      {
        path: 'contact-us',
        component: ContactUsComponent,
      },

      {
        path: 'faqs',
        component: FAQsComponent,
      },

      {
        path: 'video-guide',
        component: VideoGuideComponent,
      },
      {
        path: 'about-us',
        component: AboutUsComponent,
      },
      {
        path: 'plant-management',
        component: PlantManagementComponent,
      },
      {
        path: 'user-profile',
        component: UserProfileComponent,
      },
      {
        path: 'alerts/:type',
        component: AlertsComponent,
      },
        {
        path: 'largescaleplant',
        component: HoliumDashboardComponent,
      },
     
    ],
  },
  {
    path: 'customer',
    canActivate: [authGuard],
    component: LayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        component: CustomerDashboardComponent,
      },
      {
        path: 'plant-detail/:selectedPlantId',
        component: PlantDetailComponent,
      },
      {
        path: 'contact-us',
        component: ContactUsComponent,
      },
      {
        path: 'user-profile',
        component: UserProfileComponent,
      },
      {
        path: 'faqs',
        component: FAQsComponent,
      },

      {
        path: 'video-guide',
        component: VideoGuideComponent,
      },
      {
        path: 'about-us',
        component: AboutUsComponent,
      },
      {
        path: 'add-secondary-user',
        component: AddSecondaryUserComponent,
      },
      {
        path: 'solar-rooftop',
        component: SolarRooftopComponent,
      }
    ],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./shared/components/login/login.component').then(
        (m) => m.LoginComponent,
      ),
  },
  {
    path: 'service-engineer',
    component: LayoutComponent,
    canActivate: [authGuardSI],
    children: [
      {
        path: '',
        redirectTo: 'delete-plant',
        pathMatch: 'full',
      },

      {
        path: 'contact-us',
        component: ContactUsComponent,
      },

      {
        path: 'faqs',
        component: FAQsComponent,
      },

      {
        path: 'video-guide',
        component: VideoGuideComponent,
      },
      {
        path: 'about-us',
        component: AboutUsComponent,
      },
      {
        path: 'plant-management',
        component: PlantManagementComponent,
      },
      {
        path: 'user-profile',
        component: UserProfileComponent,
      },
    ],
  },
  {
    path:'largeScale',
    component:LayoutComponent,
    canActivate:[authGuard],
    children: [
      {
        path: '',
        component: LargeScalePlantComponent,
      },
      {
        path:'user-profile',
        component:UserProfileComponent
      },
     
    
    ]
  }
]